import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../core/services/common.service';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'app-footer',
  imports: [RouterModule, TranslateModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  
})
export class FooterComponent implements OnInit {
  langugae: any;
  currentYear: number = new Date().getFullYear();
  constructor(public commonService: CommonService) { }

  ngOnInit(): void {
    this.langugae = this.commonService.languageChange();
    let Currenturl =window.location.href;
    let tagName:any;
    if (Currenturl.includes("/manage-profile")) {
      tagName = document.getElementById('footer');
      tagName.classList.add("no_click");
    }else{
      tagName = document.getElementById('footer');
      tagName.classList.remove("no_click");
    }
  }

  flipLogoPlay(){
    console.log('Logo')
  }

  flipLogoApp(){

  }

}
